<template>
  <div id="app">
    <VSnow
      style="z-index: -1"
      containerClass="myClass"
      :density="snowOptions.density"
      :size="snowOptions.size"
      :fall_speed="snowOptions.fall_speed"
      :color="snowOptions.color"
      :opacity="snowOptions.opacity"
      :hidden="snowOptions.letIt"
    />
    <NavBar @toggle-snow="toggleSnow" />

    <div style="margin-top: 70px; padding-bottom: 65px;">
      <router-view />
    </div>

    <Footer />
  </div>
</template>

<style>
    @import "../node_modules/@syncfusion/ej2-base/styles/material.css";
    @import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
    @import "../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
</style>

<script>
import NavBar from '@/components/nav-bar';

export default {
  name: 'App',
  components: { NavBar },
  data() {
    return {
      snowOptions: {
        letIt: !Date().includes('Dec'),
        density: 50,
        fall_speed: 4,
        size: 15,
        color: "#c0cbff",
        opacity: 1,
      }
    };
  },
  methods: {
    toggleSnow(value) {
      this.snowOptions.letIt = value;
    }
  }
};
</script>
